import Client from "../client/TrackingClient"
const resource = "/api/v1"

const trackingSession = (data) => {
  return Client.post(`${resource}/tracking-session/`, data)
}
const userRepository = {
  trackingSession
}

export default userRepository
